import {combineReducers} from 'redux';
import history from './history/reducer';
import withdraw from './withdraw/reducer';

export default combineReducers({
  history,
  withdraw,
});
